import React from 'react';
import { useAtomValue } from 'jotai';
import { STORE_TYPE } from '../../../common/types/types';
import { frameCountAtom } from '../../../image/labelling-v2/atoms/annotation-atoms';
import { AnnotationDetails, AnnotationSubContent, DeleteButton, EditButton, MoreActionsButton, ObjectInstantiationButton, ShowHideButton } from '../annotation-details';
import { useEditHandler } from '../annotation-details/hooks/use-edit-handler';
import { useLockHandler } from '../annotation-details/hooks/use-lock-handler';
import { useObjectInstantiationHandler } from '../annotation-details/hooks/use-object-instantiation-handler';
import { useShowHideHandler } from '../annotation-details/hooks/use-show-hide-handler';
import type { AnnotationInfoT } from '../annotations/types';
type PropsT = {
  annotation: AnnotationInfoT;
  icon: React.ReactNode;
  isFocused: boolean;
  onDeleteAnnotation: () => void;
};
export function AnnotationDetailsItem({
  annotation,
  icon,
  isFocused,
  onDeleteAnnotation
}: PropsT) {
  const {
    handleEditAnnotation
  } = useEditHandler({
    annotation
  });
  const {
    handleObjectInstantiation
  } = useObjectInstantiationHandler({
    annotation
  });
  const {
    handleShowHideAnnotation
  } = useShowHideHandler({
    annotation,
    storeType: STORE_TYPE.ANNOTATION_STORE
  });
  const {
    handleLockAnnotation
  } = useLockHandler({
    annotation
  });
  const numFrames = useAtomValue(frameCountAtom);
  return <AnnotationDetails annotation={annotation} icon={icon} isFocused={isFocused} objectInstantiationButton={() => annotation.canCopyObjectInstance && numFrames > 1 ? <ObjectInstantiationButton annotation={annotation} onClick={handleObjectInstantiation} /> : null} editButton={() => <EditButton annotation={annotation} onClick={handleEditAnnotation} />} showHideButton={() => <ShowHideButton annotation={annotation} onClick={() => handleShowHideAnnotation()} />} deleteButton={() => <DeleteButton annotation={annotation} onClick={onDeleteAnnotation} />} moreActionsButton={() => <MoreActionsButton annotation={annotation} onLockClick={(_, locked) => handleLockAnnotation(locked)} />} subContent={() => <AnnotationSubContent annotation={annotation} />} />;
}